// Copyright 2022 - 2023 Fewcha. All rights reserved.

import { createAsyncThunk, createReducer } from "@reduxjs/toolkit";
import { RootState } from "app/store";
import axios from "axios";
import { ConfigReducer } from "features/config/types";
import { api } from "services/api";
import { defaulStatsReducer, EventInfoResType } from "./types";

export const fetchBlockchainSupply = createAsyncThunk(
  "stats/fetchBlockchainSupply",
  async (_, { getState }): Promise<{ maxSupply: number[]; totalSupply: number[]; remainingSupply: number[] }> => {
    const { config } = getState() as { config: ConfigReducer };
    const url = `${config.base.NETWORK_URL}v1/accounts/${config.base.COLLECTION_CREATOR}/resource/${config.base.MODULE_ADDRESS}`;

    const res = await axios.get(url);
    const { data } = res.data;

    const { max_supply: maxSupply, total_supply: totalSupply } = data as {
      max_supply: string[];
      total_supply: string[];
    };
    const parsedMaxSupply = maxSupply.map((item) => Number(item));
    const parsedTotalSupply = totalSupply.map((item) => Number(item));

    return {
      maxSupply: parsedMaxSupply,
      totalSupply: parsedTotalSupply,

      remainingSupply: parsedMaxSupply.map((max, index) => {
        const result = max - parsedTotalSupply[index];
        if (result > 0) {
          return result;
        }
        return 0;
      }),
    };
  },
);

export const getPrice = createAsyncThunk(
  "stats/getPrice",
  async (): Promise<{ rawPrice: string[]; price: string[] }> => {
    try {
      const res = await api().get<EventInfoResType>("mainnet/membership/info");

      const { data, status } = res;

      if (status !== 200) {
        return defaulStatsReducer;
      }

      const { price } = data;

      return {
        rawPrice: price,
        price: price.map((item) => item),
      };
    } catch (error) {
      console.error(error);
    }

    return { rawPrice: [], price: [] };
  },
);

const statsReducer = createReducer(defaulStatsReducer, (builder) => {
  builder
    .addCase(getPrice.fulfilled, (state, action) => {
      state.price = action.payload.price;
      state.rawPrice = action.payload.rawPrice;
    })
    .addCase(fetchBlockchainSupply.fulfilled, (state, action) => {
      state.maxSupply = action.payload.maxSupply;
      state.totalSupply = action.payload.totalSupply;
      state.remainingSupply = action.payload.remainingSupply;
    });
});

export const selectStats = (state: RootState) => state.stats;

export default statsReducer;
